import _find from 'lodash/find'
import moment from 'moment'

export const tasksiteOrdersState = {
  name: 'customers.customer.tasksites.orders',
  url: '/:tasksiteId/orders/:year',
  params: {
    year: new Date().getFullYear().toString(), // Default value
  },
  views: {
    'content@customers': 'tasksiteOrdersComponent',
  },
  resolve: {
    tasksite: (tasksites, $stateParams) => {
      'ngInject'
      return _find(tasksites, { code: $stateParams.tasksiteId })
    },
    orders: (customer, $stateParams) => {
      'ngInject'
      const from = moment().dayOfYear(1).month(0).year($stateParams.year).format('YYYY-MM-DD')
      const to = moment().dayOfYear(31).month(11).year($stateParams.year).format('YYYY-MM-DD')
      return customer.getTasksiteOrders($stateParams.tasksiteId, { from, to })
    },
  },
}



// WEBPACK FOOTER //
// ./app/orders/orders.states.js